
export const templateUrlConfigSys= {
  sysuser: './sysuser-editPkg.component.html',
  syska: './syska-editPkg.component.html',
  sysse: './sysse-edit.component.html',
  sysai85: './sysai85.component.html',
  admi10: './admi10Pkg.component.html',
}

export * from "./syssePkg.service";
export * from "./sysse.service";
export * from "./syskaPkg.service";
export * from "./syska.service";
